import React from 'react'
import { Circle } from 'rc-progress'
import Item from './item'
import iconCheck from '../../../../../../images/iconCheck.png'
import iconOver from '../../../../../../images/iconOver.png'
import CircularProgress from '@material-ui/core/CircularProgress';


const MacroGraph = (props) => {
  const macroData = props.macroData
  const trackerData = props.trackerData
  const relatedWeighInDateString = props.relatedWeighInDateString
  const setShowConsumedMacros = props.setShowConsumedMacros

  const getProteinTextColor = (remainingProtein, targetProtein) => { 
    return '#FFF'
  }

  const getProteinCircleColor = (remainingProtein, targetProtein) => {
    if (targetProtein === 0)
      return '#FFF'
  
    const proteinSlope = Math.round((1/30 * targetProtein) + (6.6666666667))
    if(targetProtein <= 100) {
      if (remainingProtein < -10)
        return '#ed28a5'
      else if (remainingProtein >= -10 && remainingProtein <= 10)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else if(targetProtein > 100 && targetProtein < 250) {
      if (remainingProtein < -proteinSlope)
        return '#ed28a5'
      else if (remainingProtein >= -proteinSlope && remainingProtein <= proteinSlope)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else {
      if (remainingProtein < -15)
        return '#ed28a5'
      else if (remainingProtein >= -15 && remainingProtein <= 15)
        return '#00ee46'
      else
        return '#31bfff'
    }
  }

  const getCarbsTextColor = (remainingCarbs, targetCarbs) => {
    return '#FFF'
  }

  const getCarbsCircleColor = (remainingCarbs, targetCarbs) => {
    if (targetCarbs === 0)
      return '#FFF'

    const carbsSlope = Math.round((11/450 * targetCarbs) + (3.7777777778))
    if(targetCarbs <= 50) {
      if (remainingCarbs < -5)
        return '#ed28a5'
      else if (remainingCarbs >= -5 && remainingCarbs <= 5)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else if(targetCarbs > 50 && targetCarbs < 500) {
      if (remainingCarbs < -carbsSlope)
        return '#ed28a5'
      else if (remainingCarbs >= -carbsSlope && remainingCarbs <= carbsSlope)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else {
      if (remainingCarbs < -16)
        return '#ed28a5'
      else if (remainingCarbs >= -16 && remainingCarbs <= 16)
        return '#00ee46'
      else
        return '#31bfff'
    }
  }

  const getFatTextColor = (remainingFat, targetFat) => {
    return '#FFF'
  }

  const getFatCircleColor = (remainingFat, targetFat) => {
    if (targetFat === 0)
      return '#FFF'

    const fatSlope = Math.round((2/75 * targetFat) + (10/3))
    if(targetFat <= 25) {
      if (remainingFat < -4)
        return '#ed28a5'
      else if (remainingFat >= -4 && remainingFat <= 4)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else if(targetFat > 25 && targetFat < 175) {
      if (remainingFat < -fatSlope)
        return '#ed28a5'
      else if (remainingFat >= -fatSlope && remainingFat <= fatSlope) {
        return '#00ee46'
      }
      else
        return '#31bfff'
    }

    else {
      if (remainingFat < -8)
        return '#ed28a5'
      else if (remainingFat >= -8 && remainingFat <= 8)
        return '#00ee46'
      else
        return '#31bfff'
    }
  }

  const handleProteinIndicator = (targetProtein) => {
    if(targetProtein === null || targetProtein === undefined || targetProtein === 0) {
      return 'circle-graph-indicator-none'
    } else {
      return 'circle-graph-indicator'
    }
  }

  const handleCarbsIndicator = (targetCarbs) => {
    if(targetCarbs === null || targetCarbs === undefined || targetCarbs === 0) {
      return 'circle-graph-indicator-none'
    } else {
      return 'circle-graph-indicator'
    }
  }


  const handleFatIndicator = (targetFat) => {
    if(targetFat === null || targetFat === undefined || targetFat === 0) {
      return 'circle-graph-indicator-none'
    } else {
      return 'circle-graph-indicator'
    }
  }


  // const handleFlip = (e) => {
  //   e.preventDefault()
  //   props.updateShowWeeklyAvg(!props.showWeeklyAvg)
  // }

  const formatOffset = (offset) => {
    return offset < 0 ? ('- ' + (Math.round(- offset))) : ('+ ' + Math.round(offset))
  }

  const renderRangeText = (color) => {
    if(color === '#00ee46') {
      return (
        <p className="tracker-range-label"><img src={iconCheck} alt="check" /> IN RANGE</p>
      )
    } else {
      return (
        <p className="tracker-range-label"><img src={iconOver} alt="alert" /> OVER RANGE</p>
      )
    }
  }

  const getFatCaloriesRatio = (macros) => {
    return macros.fat * 9 / ((macros.protein + macros.carbs) * 4 + macros.fat * 9)
  }

  const renderGraphs = () => {
    let consumedProtein = 0
    let consumedCarbs = 0
    let consumedFat = 0
    let percentProtein = 0
    let percentCarbs = 0
    let percentFat = 0
    let proteinAngleDegrees = 0;
    let carbsAngleDegrees = 0;
    let fatAngleDegrees = 0;
    let avgProteinAngleDegrees = 0;
    let avgCarbsAngleDegrees = 0;
    let avgFatAngleDegrees = 0;
    let avgProtein = macroData.avgProtein
    let avgCarbs = macroData.avgCarbs
    let avgFat = macroData.avgFat
    let avgTargetProtein = macroData.avgTargetProtein
    let avgTargetCarbs = macroData.avgTargetCarbs
    let avgTargetFat = macroData.avgTargetFat
    let proteinAvgCompleted = 0
    let carbsAvgCompleted = 0
    let fatAvgCompleted = 0

    let targetProtein = 0
    let targetCarbs = 0
    let targetFat = 0
    let movingTargetsOption = 0
    let part4Invoked = 0
    let part4FatPerMyriad = 0
    let part4OldFatRatio = 0
    let part4CarbsChange = 0
    let part4FatChange = 0

    const relatedWeighInDetails = macroData.weighInDetails[relatedWeighInDateString]
    let key = trackerData.selectedTrackerDate
    if(!(key in relatedWeighInDetails.result.stage_5)) {
      key = null
      for(let candidate_key in relatedWeighInDetails.result.stage_5) {
        if(key === null || candidate_key > key) {
          key = candidate_key
        }
      }
    }
    targetProtein = Math.round(relatedWeighInDetails.result.stage_5[key].protein)
    targetCarbs = Math.round(relatedWeighInDetails.result.stage_5[key].carbs)
    targetFat = Math.round(relatedWeighInDetails.result.stage_5[key].fat)
    movingTargetsOption = relatedWeighInDetails.result.daily_adjustments[key].moving_targets
    part4Invoked = relatedWeighInDetails.result.daily_adjustments[key].part_4_invoked
    part4FatPerMyriad = relatedWeighInDetails.result.daily_adjustments[key].part_4_fat_per_myriad
    if(part4Invoked) {
      if(movingTargetsOption) {
        part4OldFatRatio = getFatCaloriesRatio(relatedWeighInDetails.result.stage_2[key])
        part4CarbsChange = relatedWeighInDetails.result.stage_3[key].carbs - relatedWeighInDetails.result.stage_2[key].carbs
        part4FatChange = relatedWeighInDetails.result.stage_3[key].fat - relatedWeighInDetails.result.stage_2[key].fat
      } else {
        part4OldFatRatio = getFatCaloriesRatio(relatedWeighInDetails.result.stage_1[key])
        part4CarbsChange = relatedWeighInDetails.result.stage_4[key].carbs - relatedWeighInDetails.result.stage_1[key].carbs
        part4FatChange = relatedWeighInDetails.result.stage_4[key].fat - relatedWeighInDetails.result.stage_1[key].fat
      }
    }

    let items = trackerData.timeline[trackerData.selectedTrackerDate]
    const proteinSlope = Math.round((1/30 * targetProtein) + (6.6666666667))
    const carbsSlope = Math.round((11/450 * targetCarbs) + (3.7777777778))
    const fatSlope = Math.round((2/75 * targetFat) + (10/3))

    const avgProteinSlope = Math.round((1/30 * avgTargetProtein) + (6.6666666667))
    const avgCarbsSlope = Math.round((11/450 * avgTargetCarbs) + (3.7777777778))
    const avgFatSlope = Math.round((2/75 * avgTargetFat) + (10/3))


    if (items) {
      items.forEach(item => {
        item = new Item(item);
        if(item.itemType === 'recipe') {
          consumedProtein += item.getRecipeProtein();
          consumedCarbs += item.getRecipeCarbs();
          consumedFat += item.getRecipeFat();
        }
        else {
          consumedProtein += item.getProtein();
          consumedCarbs += item.getCarbs();
          consumedFat += item.getFat();
        }
      });
    }

    if(targetProtein === 0) {
      percentProtein = consumedProtein / 1
      proteinAngleDegrees = 0
    } else if(targetProtein <= 100) {
      percentProtein = ((consumedProtein / (targetProtein + 10)) * 100).toFixed(2)
      proteinAngleDegrees = ((targetProtein - 10)/(targetProtein + 10))* 360
      avgProteinAngleDegrees = ((avgTargetProtein - 10)/(avgTargetProtein + 10))* 360
    } else if(targetProtein > 100 && targetProtein < 250) {
      percentProtein = ((consumedProtein / (targetProtein + proteinSlope)) * 100).toFixed(2)
      proteinAngleDegrees = ((targetProtein - proteinSlope)/(targetProtein + proteinSlope))*360
      avgProteinAngleDegrees = ((avgTargetProtein - avgProteinSlope)/(avgTargetProtein + avgProteinSlope))*360
    } else {
      percentProtein = ((consumedProtein / (targetProtein + 15)) * 100).toFixed(2)
      proteinAngleDegrees = ((targetProtein - 15)/(targetProtein + 15))*360
      avgProteinAngleDegrees = ((avgTargetProtein - 15)/(avgTargetProtein + 15))*360
    }


    if(avgTargetProtein === 0) {
      proteinAvgCompleted = avgProtein / 1
    } else if(targetProtein <= 100) {
      proteinAvgCompleted = ((avgProtein / (avgTargetProtein + 10)) * 100).toFixed(2)
    } else if(targetProtein > 100 && targetProtein < 250) {
      proteinAvgCompleted = ((avgProtein / (avgTargetProtein + proteinSlope)) * 100).toFixed(2)
    } else {
      proteinAvgCompleted = ((avgProtein / (avgTargetProtein + 15)) * 100).toFixed(2)
    }

   
    if(targetCarbs === 0) {
      percentCarbs = consumedCarbs / 1
      carbsAngleDegrees = 0
    } else if(targetCarbs <= 50) {
      percentCarbs = ((consumedCarbs / (targetCarbs + 5)) * 100).toFixed(2);
      carbsAngleDegrees = ((targetCarbs - 5)/(targetCarbs + 5)) * 360
      avgCarbsAngleDegrees = ((avgTargetCarbs - 5)/(avgTargetCarbs + 5)) * 360
    } else if(targetCarbs > 50 && targetCarbs < 500) {
      percentCarbs = ((consumedCarbs / (targetCarbs + carbsSlope)) * 100).toFixed(2);
      carbsAngleDegrees = (((targetCarbs - carbsSlope)/(targetCarbs + carbsSlope))*360)
      avgCarbsAngleDegrees = (((avgTargetCarbs - avgCarbsSlope)/(avgTargetCarbs + avgCarbsSlope))*360)
    } else {
      percentCarbs = ((consumedCarbs / (targetCarbs + 16)) * 100).toFixed(2);
      carbsAngleDegrees = (((targetCarbs - 16)/(targetCarbs + 16))*360)
      avgCarbsAngleDegrees = (((avgTargetCarbs - 16)/(avgTargetCarbs + 16))*360)
    }

    if(avgTargetCarbs === 0)
      carbsAvgCompleted = avgCarbs / 1
    else if(avgTargetCarbs <= 50)
      carbsAvgCompleted = ((avgCarbs / (avgTargetCarbs + 5)) * 100).toFixed(2)
    else if(avgTargetCarbs > 50 && avgTargetCarbs < 500)
      carbsAvgCompleted = ((avgCarbs / (avgTargetCarbs + carbsSlope)) * 100).toFixed(2)
    else 
      carbsAvgCompleted = ((avgCarbs / (avgTargetCarbs + 16)) * 100).toFixed(2)
    
    if(targetFat === 0) {
      percentFat = consumedFat / 1
      fatAngleDegrees = 0
    } else if(targetFat <= 25) {
      percentFat = ((consumedFat / (targetFat + 4)) * 100).toFixed(2)
      fatAngleDegrees = ((targetFat - 4)/(targetFat + 4))* 360
      avgFatAngleDegrees = ((avgTargetFat - 4)/(avgTargetFat + 4))* 360
    } else if(targetFat > 25 && targetFat < 175) {
      percentFat = ((consumedFat / (targetFat + fatSlope)) * 100).toFixed(2)
      fatAngleDegrees = (((targetFat - fatSlope)/(targetFat + fatSlope))*360)
      avgFatAngleDegrees = (((avgTargetFat - avgFatSlope)/(avgTargetFat + avgFatSlope))*360)
    } else {
      percentFat = ((consumedFat / (targetFat + 8)) * 100).toFixed(2)
      fatAngleDegrees = ((targetFat - 8)/(targetFat + 8))*360
      avgFatAngleDegrees = ((avgTargetFat - 8)/(avgTargetFat + 8))*360

    }

    if(avgTargetFat === 0) {
      fatAvgCompleted = avgFat / 1
    } else if(avgTargetFat <= 25) {
      fatAvgCompleted = ((avgFat / (avgTargetFat + 4)) * 100).toFixed(2)
    } else if(targetFat > 25 && avgTargetFat < 175) {
      fatAvgCompleted = ((avgFat / (avgTargetFat + fatSlope)) * 100).toFixed(2)
    } else {
      fatAvgCompleted = ((avgFat / (avgTargetFat + 8)) * 100).toFixed(2)
    }

    let remainingProtein = Math.round(targetProtein - consumedProtein);
    let remainingCarbs = Math.round(targetCarbs - consumedCarbs);
    let remainingFat = Math.round(targetFat - consumedFat);
    let remainingAvgCarbs = Math.round(avgTargetCarbs - avgCarbs);
    let remainingAvgFat = Math.round(avgTargetFat - avgFat);
    let remainingAvgProtein = Math.round(avgTargetProtein - avgProtein);

    let showProteinMinMax = !(getProteinCircleColor(remainingProtein, targetProtein) === '#00ee46' || getProteinCircleColor(remainingProtein, targetProtein) === '#ed28a5')
    let showCarbsMinMax = !(getCarbsCircleColor(remainingCarbs, targetCarbs) === '#00ee46' || getCarbsCircleColor(remainingCarbs, targetCarbs) === '#ed28a5') 
    let showFatMinMax = !(getFatCircleColor(remainingFat, targetFat) === '#00ee46' || getFatCircleColor(remainingFat, targetFat) === '#ed28a5') 

    let proteinRangeText = renderRangeText(getProteinCircleColor(remainingProtein, targetProtein))
    let carbsRangeText = renderRangeText(getCarbsCircleColor(remainingCarbs, targetCarbs))
    let fatRangeText = renderRangeText(getFatCircleColor(remainingFat, targetFat))

    
    let showAvgProteinMinMax = !(getProteinCircleColor(remainingAvgProtein, avgTargetProtein) === '#00ee46' || getProteinCircleColor(remainingAvgProtein, avgTargetProtein) === '#ed28a5')
    let showAvgCarbsMinMax = !(getCarbsCircleColor(remainingAvgCarbs, avgTargetCarbs) === '#00ee46' || getCarbsCircleColor(remainingAvgCarbs, avgTargetCarbs) === '#ed28a5')
    let showAvgFatMinMax = !(getFatCircleColor(remainingAvgFat, avgTargetFat) === '#00ee46' || getFatCircleColor(remainingAvgFat, avgTargetFat) === '#ed28a5')

    let avgProteinRangeText = renderRangeText(getProteinCircleColor(remainingAvgProtein, avgTargetProtein))
    let avgCarbsRangeText = renderRangeText(getCarbsCircleColor(remainingAvgCarbs, avgTargetCarbs))
    let avgFatRangeText = renderRangeText(getCarbsCircleColor(remainingAvgFat, avgTargetFat))

    return props.vacationMode === 2 ? (
      <div>
        <div className="tracker-macro-count-container" >
          <button className="active">Consumed</button>
        </div>
        {props.showWeeklyAvg ?
          <div className="tracker-graph-container" key="back">
            {props.daysSinceLastCheckin === 0 &&
              <div className="no-averages">
                <p>No Averages yet. Check back in after a few days of tracking.</p>
              </div>
            }
            <div>
              <div className="circle-container" style={{ height: '165px' }}>
                {props.daysSinceLastCheckin !== 0 &&
                  <>
                    <div className="tracker-graph-data">
                      {(avgProtein !== undefined) ?
                      <div className="tracker-graph-macros">
                        <h6>Avg Protein</h6>
                        <h4 style={{ color: '#FFF' }}>{Math.round(avgProtein).toString()}</h4>
                      </div>
                      :
                      <div className="tracker-graph-macros" style={{ padding: 0 }}>
                        <CircularProgress size={32} />
                      </div>
                      }
                    </div>
                  </>
                }
              </div>
            </div>
            <div>
              <div className="circle-container circle-center" style={{ height: '165px' }}>
                {props.daysSinceLastCheckin !== 0 &&
                  <>
                    <div className="tracker-graph-data">
                      {(avgCarbs !== undefined) ?
                      <div className="tracker-graph-macros">
                        <h6>Avg Carbs</h6>
                        <h4 style={{ color: '#FFF' }}>{Math.round(avgCarbs).toString()}</h4>
                      </div>
                      :
                      <div className="tracker-graph-macros" style={{ padding: 0 }}>
                        <CircularProgress size={32} />
                      </div>
                      }
                    </div>
                  </>
                }
              </div>
            </div>
            <div>
              <div className="circle-container" style={{ height: '165px' }}>
                {props.daysSinceLastCheckin !== 0 &&
                  <>
                    <div className="tracker-graph-data">
                      {(avgFat !== undefined) ?
                      <div className="tracker-graph-macros">
                        <h6>Avg Fat</h6>
                        <h4 style={{ color: '#FFF' }}>{Math.round(avgFat).toString()}</h4>
                      </div>
                      :
                      <div className="tracker-graph-macros" style={{ padding: 0 }}>
                        <CircularProgress size={32} />
                      </div>
                      }
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        :
          <div className="tracker-graph-container" key="front" style={{background: 'none'}}>
            <div className="circle-container" style={{ height: '165px' }}>
              <div className="tracker-graph-data">
                <div className="tracker-graph-macros">
                  <h6>Protein</h6>
                  <h4 style={{ color: '#FFF' }}>{Math.round(consumedProtein)}</h4>
                </div>
              </div>
            </div>
            <div className="circle-container circle-center" style={{ height: '165px' }}>
              <div className="tracker-graph-data">
                <div className="tracker-graph-macros">
                  <h6>Carbs</h6>
                  <h4 style={{ color: '#FFF' }}>{Math.round(consumedCarbs)}</h4>
                </div>
              </div>
            </div>
            <div className="circle-container" style={{ height: '165px' }}>
              <div className="tracker-graph-data">
                <div className="tracker-graph-macros">
                  <h6>Fat</h6>
                  <h4 style={{ color: '#FFF' }}>{Math.round(consumedFat)}</h4>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    ) : (
      <div>
        <div className="tracker-macro-count-container" >
          <button className={trackerData.showConsumedMacros ? "active" : ""}  onClick={() => setShowConsumedMacros(true)}>Consumed</button>
          <button className={trackerData.showConsumedMacros ? "" : "active"} onClick={() => setShowConsumedMacros(false)}>Remaining</button>
          {/* {showMovingTargetsAndSwap(movingTargetsOption, part4Invoked, part4FatPerMyriad, part4OldFatRatio, part4CarbsChange, part4FatChange)} */}
        </div>
        {props.overview ? 
          <div className="tracker-graph-container" key="back">
            <div>
              <div className="circle-container" >
                {!showAvgProteinMinMax && 
                  avgProteinRangeText
                }
                <Circle
                  percent={proteinAvgCompleted}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeColor={getProteinCircleColor(remainingAvgProtein, avgTargetProtein)}
                  trailWidth="5"
                  trailColor="#1d2345"
                />
                <div className="tracker-graph-data">
                  {(avgProtein !== undefined) ?
                  <div className="tracker-graph-macros">
                    <h6>Avg Protein</h6>
                    <h4 style={{ color: getProteinTextColor(remainingAvgProtein, avgTargetProtein) }}>{trackerData.showConsumedMacros ? Math.round(avgProtein).toString() : Math.round(remainingAvgProtein).toString()}</h4>
                    <h6>of {Math.round(avgTargetProtein).toString()}</h6>
                  </div>
                  :
                  <div className="tracker-graph-macros" style={{ padding: 0 }}>
                    <CircularProgress size={32} />
                  </div>
                  }
                </div>
                <div className='circle-graph-indicator-middle'>
                  {showAvgProteinMinMax && <p>MAX</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
                <div style={{ transform: `translateX(-50%) rotate(${avgProteinAngleDegrees}deg)`}} className={handleProteinIndicator(avgTargetProtein)}>
                  {showAvgProteinMinMax && <p style={{ transform: `translateX(${avgProteinAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-avgProteinAngleDegrees}deg)`}}>MIN</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
              </div>
            </div>
            <div>
              <div className="circle-container circle-center" >
                {!showAvgCarbsMinMax && 
                  avgCarbsRangeText
                }
                <Circle
                  percent={carbsAvgCompleted}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeColor={getCarbsCircleColor(remainingAvgCarbs, avgTargetCarbs)}
                  trailWidth="5"
                  trailColor="#1d2345"
                />
                <div className="tracker-graph-data">
                  {(avgCarbs !== undefined) ?
                  <div className="tracker-graph-macros">
                    <h6>Avg Carbs</h6>
                    <h4 style={{ color: getCarbsTextColor(remainingAvgCarbs, avgTargetCarbs) }}>{trackerData.showConsumedMacros ? Math.round(avgCarbs).toString() : Math.round(remainingAvgCarbs).toString()}</h4>
                    <h6>of {Math.round(avgTargetCarbs).toString()}</h6>
                  </div>
                  :
                  <div className="tracker-graph-macros" style={{ padding: 0 }}>
                    <CircularProgress size={32} />
                  </div>
                  }
                </div>
                <div className='circle-graph-indicator-middle'>
                  {showAvgCarbsMinMax && <p>MAX</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
                <div style={{ transform: `translateX(-50%) rotate(${avgCarbsAngleDegrees}deg)` }} className={handleCarbsIndicator(avgTargetCarbs)}>
                  {showAvgCarbsMinMax && <p style={{ transform: `translateX(${avgCarbsAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-avgCarbsAngleDegrees}deg)`}}>MIN</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
              </div>
            </div>
            <div>
              <div className="circle-container" >
                {!showAvgFatMinMax && 
                  avgFatRangeText
                }
                <Circle
                  percent={fatAvgCompleted}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeColor={getFatCircleColor(remainingAvgFat, avgTargetFat)}
                  trailWidth="5"
                  trailColor="#1d2345"
                />
                <div className="tracker-graph-data">
                  {(avgFat !== undefined) ?
                  <div className="tracker-graph-macros">
                    <h6>Avg Fat</h6>
                    <h4 style={{ color: getFatTextColor(remainingAvgFat, avgTargetFat) }}>{trackerData.showConsumedMacros ? Math.round(avgFat).toString() : Math.round(remainingAvgFat).toString()}</h4>
                    <h6>of {Math.round(avgTargetFat).toString()}</h6>
                  </div>
                  :
                  <div className="tracker-graph-macros" style={{ padding: 0 }}>
                    <CircularProgress size={32} />
                  </div>
                  }
                </div>
                <div className='circle-graph-indicator-middle'>
                  {showAvgFatMinMax && <p>MAX</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
                <div style={{ transform: `translateX(-50%) rotate(${avgFatAngleDegrees}deg)` }} className={handleFatIndicator(avgTargetFat)}>
                  {showAvgFatMinMax && <p style={{ transform: `translateX(${avgFatAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-avgFatAngleDegrees}deg)`}}>MIN</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
              </div>
            </div>
          </div>
        :
          props.showWeeklyAvg ?
            <div className="tracker-graph-container" key="back">
              {props.daysSinceLastCheckin === 0 && 
                <div className="no-averages">
                  <p>No Averages yet. Check back in after a few days of tracking.</p>
                </div>
              }
              <div>
                <div className="circle-container" >
                  {!showAvgProteinMinMax && 
                    avgProteinRangeText
                  }
                  <Circle
                    percent={proteinAvgCompleted}
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeColor={getProteinCircleColor(remainingAvgProtein, avgTargetProtein)}
                    trailWidth="5"
                    trailColor="#1d2345"
                  />
                  {props.daysSinceLastCheckin !== 0 && 
                    <>
                      <div className="tracker-graph-data">
                        {(avgProtein !== undefined) ?
                        <div className="tracker-graph-macros">
                          <h6>Avg Protein</h6>
                          <h4 style={{ color: getProteinTextColor(remainingAvgProtein, avgTargetProtein) }}>{trackerData.showConsumedMacros ? Math.round(avgProtein).toString() : Math.round(remainingAvgProtein).toString()}</h4>
                          <h6>of {Math.round(avgTargetProtein).toString()}</h6>
                        </div>
                        :
                        <div className="tracker-graph-macros" style={{ padding: 0 }}>
                          <CircularProgress size={32} />
                        </div>
                        }
                      </div>
                      <div className='circle-graph-indicator-middle'>
                        {showAvgProteinMinMax && <p>MAX</p>}
                        <div className='circle-graph-bar-white'></div>
                      </div>
                      <div style={{ transform: `translateX(-50%) rotate(${avgProteinAngleDegrees}deg)`}} className={handleProteinIndicator(avgTargetProtein)}>
                        {showAvgCarbsMinMax && <p style={{ transform: `translateX(${avgProteinAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-avgProteinAngleDegrees}deg)`}}>MIN</p>}
                        <div className='circle-graph-bar-white'></div>
                      </div>
                    </>
                  }
                </div>
              </div>
              <div>
                <div className="circle-container circle-center" >
                  {!showAvgCarbsMinMax && 
                    avgCarbsRangeText
                  }
                  <Circle
                    percent={carbsAvgCompleted}
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeColor={getCarbsCircleColor(remainingAvgCarbs, avgTargetCarbs)}
                    trailWidth="5"
                    trailColor="#1d2345"
                  />
                  {props.daysSinceLastCheckin !== 0 && 
                    <>
                      <div className="tracker-graph-data">
                        {(avgCarbs !== undefined) ?
                        <div className="tracker-graph-macros">
                          <h6>Avg Carbs</h6>
                          <h4 style={{ color: getCarbsTextColor(remainingAvgCarbs, avgTargetCarbs) }}>{trackerData.showConsumedMacros ? Math.round(avgCarbs).toString() : Math.round(remainingAvgCarbs).toString()}</h4>
                          <h6>of {Math.round(avgTargetCarbs).toString()}</h6>
                        </div>
                        :
                        <div className="tracker-graph-macros" style={{ padding: 0 }}>
                          <CircularProgress size={32} />
                        </div>
                        }
                      </div>
                      <div className='circle-graph-indicator-middle'>
                        {showAvgCarbsMinMax && <p>MAX</p>}
                        <div className='circle-graph-bar-white'></div>
                      </div>
                      <div style={{ transform: `translateX(-50%) rotate(${avgCarbsAngleDegrees}deg)` }} className={handleCarbsIndicator(avgTargetCarbs)}>
                        {showAvgCarbsMinMax && <p style={{ transform: `translateX(${avgCarbsAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-avgCarbsAngleDegrees}deg)`}}>MIN</p>}
                        <div className='circle-graph-bar-white'></div>
                      </div>
                    </>
                  }
                </div>
              </div>
              <div>
                <div className="circle-container" >
                  {!showAvgFatMinMax && 
                    avgFatRangeText
                  }
                  <Circle
                    percent={fatAvgCompleted}
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeColor={getFatCircleColor(remainingAvgFat, avgTargetFat)}
                    trailWidth="5"
                    trailColor="#1d2345"
                  />
                  {props.daysSinceLastCheckin !== 0 && 
                    <>
                      <div className="tracker-graph-data">
                        {(avgFat !== undefined) ?
                        <div className="tracker-graph-macros">
                          <h6>Avg Fat</h6>
                          <h4 style={{ color: getFatTextColor(remainingAvgFat, avgTargetFat) }}>{trackerData.showConsumedMacros ? Math.round(avgFat).toString() : Math.round(remainingAvgFat).toString()}</h4>
                          <h6>of {Math.round(avgTargetFat).toString()}</h6>
                        </div>
                        :
                        <div className="tracker-graph-macros" style={{ padding: 0 }}>
                          <CircularProgress size={32} />
                        </div>
                        }
                      </div>
                      <div className='circle-graph-indicator-middle'>
                        {showAvgFatMinMax && <p>MAX</p>}
                        <div className='circle-graph-bar-white'></div>
                      </div>
                      <div style={{ transform: `translateX(-50%) rotate(${avgFatAngleDegrees}deg)` }} className={handleFatIndicator(avgTargetFat)}>
                        {showAvgFatMinMax && <p style={{ transform: `translateX(${avgFatAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-avgFatAngleDegrees}deg)`}}>MIN</p>}
                        <div className='circle-graph-bar-white'></div>
                      </div>
                    </>
                  }
                </div>
              </div>
            </div>
          :
          <div className="tracker-graph-container" key="front" style={{background: 'none'}}>
              <div className="circle-container">
                {!showProteinMinMax && 
                  proteinRangeText
                }
                <Circle
                  percent={percentProtein}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeColor={getProteinCircleColor(remainingProtein, targetProtein)}
                  trailWidth="5"
                  trailColor="#1d2345"
                />
                <div className="tracker-graph-data">
                  <div className="tracker-graph-macros">
                    <h6>Protein</h6>
                    <h4 style={{ color: getProteinTextColor(remainingProtein, targetProtein) }}>{trackerData.showConsumedMacros ? Math.round(consumedProtein) : Math.round(remainingProtein)}</h4>
                    <h6>of {Math.round(targetProtein).toString()}</h6>
                  </div>
                </div>
                <div className='circle-graph-indicator-middle'>
                  {showProteinMinMax && <p>MAX</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
                <div style={{ transform: `translateX(-50%) rotate(${proteinAngleDegrees}deg)`}} className={handleProteinIndicator(targetProtein)}>
                  {showProteinMinMax && <p style={{ transform: `translateX(${proteinAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-proteinAngleDegrees}deg)`}}>MIN</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
              </div>
              <div className="circle-container circle-center" >
                {!showCarbsMinMax && 
                  carbsRangeText
                }
                <Circle
                  percent={percentCarbs}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeColor={getCarbsCircleColor(remainingCarbs, targetCarbs)}
                  trailWidth="5"
                  trailColor="#1d2345"
                />
                <div className="tracker-graph-data">
                  <div className="tracker-graph-macros">
                    <h6>Carbs</h6>
                    <h4 style={{ color: getCarbsTextColor(remainingCarbs, targetCarbs) }}>{trackerData.showConsumedMacros ? Math.round(consumedCarbs) : Math.round(remainingCarbs)}</h4>
                    <h6>of {Math.round(targetCarbs).toString()}</h6>
                  </div>                
                </div>
                <div className='circle-graph-indicator-middle'>
                  {showCarbsMinMax && <p>MAX</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
                <div style={{ transform: `translateX(-50%) rotate(${carbsAngleDegrees}deg)` }} className={handleCarbsIndicator(targetCarbs)}>
                  {showCarbsMinMax && <p style={{ transform: `translateX(${carbsAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-carbsAngleDegrees}deg)`}}>MIN</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
              </div>
              <div className="circle-container" >
                {!showFatMinMax && 
                  fatRangeText
                }
                <Circle
                  percent={percentFat}
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeColor={getFatCircleColor(remainingFat, targetFat)}
                  trailWidth="5"
                  trailColor="#1d2345"
                />
                <div className="tracker-graph-data">
                  <div className="tracker-graph-macros">
                    <h6>Fat</h6>
                    <h4 style={{ color: getFatTextColor(remainingFat, targetFat) }}>{trackerData.showConsumedMacros ? Math.round(consumedFat) : Math.round(remainingFat)}</h4>
                    <h6>of {Math.round(targetFat).toString()}</h6>
                  </div>
                </div>
                <div className='circle-graph-indicator-middle'>
                  {showFatMinMax && <p>MAX</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
                <div style={{ transform: `translateX(-50%) rotate(${fatAngleDegrees}deg)` }} className={handleFatIndicator(targetFat)}>
                  {showFatMinMax && <p style={{ transform: `translateX(${fatAngleDegrees < 300 ? '-10' : '-50' }%) translateY(-50%) rotate(${360-fatAngleDegrees}deg)`}}>MIN</p>}
                  <div className='circle-graph-bar-white'></div>
                </div>
              </div>
            </div>
        }
      </div>
    )
  }

  return <div>{renderGraphs()}</div>
}

export default MacroGraph

